import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateProfile, showAvatarPreview } from '../../actions/authAction'
import { UPDATE_PROFILE_RESET } from '../../constants/actionTypes'
import { toast } from 'react-toastify';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';

const ProfileUpdate = () => {


    const dispatch = useDispatch()

    const { loading, message, user } = useSelector(state => state.updateProfile)
    const [first_name, setFirstName] = useState();
    const [last_name, setLastName] = useState();
    const [email, setEmail] = useState();
    const [contact_no, setContactNo] = useState();
    // const [isUpdated, setIsUpdated] = useState(false);
    const [errors, setError] = useState({})
    const [avatar, setAvatar] = useState();
    let [mediaError, setMediaError] = useState({})

    useEffect(() => {
        if (user) {
            setFirstName(user?.first_name)
            setLastName(user?.last_name)
            setEmail(user?.email)
            setContactNo(user?.contact_no)
        }

        return () => {
            dispatch({ type: UPDATE_PROFILE_RESET })
        }
    }, [user, dispatch]);

    useEffect(() => {
        if (message) {
            toast.success(message)
        }
    }, [message])

    useEffect(() => {
        if (user) {
            // if (first_name !== user.first_name || email !== user.email || last_name !== user.last_name || contact_no !== user.contact_no) {
            //     setIsUpdated(true)
            // } else {
            //     setIsUpdated(false)
            // }
        }
    }, [user])

    
    const formatBytes = (bytes) => {
        var kb = 1024;
        var ndx = Math.floor( Math.log(bytes) / Math.log(kb) );
        var fileSizeTypes = ["bytes", "kb", "mb", "gb", "tb", "pb", "eb", "zb", "yb"];
      
        return {
          size: +(bytes / kb / kb).toFixed(2),
          type: fileSizeTypes[ndx]
        };
    }

    const handleChange = (e) => {
        if (e.target.name === 'avatar') {
            let file_type = e.target.files[0]?.type;
            let fsize = e.target.files[0]?.size;
            let convertFileSize = formatBytes(fsize);
            if(!["image/jpeg", "image/png", "image/jpg"].includes(file_type)) {
                setMediaError(prev => ({ ...prev, avatar: "Uploaded file has unsupported format" }))
                return false;
            }
            if(fsize >= 5000000) {
                setMediaError(prev => ({ ...prev, avatar: 'Maximum file size 5 MB. This file size is: ' + convertFileSize.size + " " + convertFileSize.type + '' }))
                return false;
            }
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    if (reader.result.split('/')[0] === 'data:image') {
                        dispatch(showAvatarPreview(reader.result))
                        setMediaError(prev => ({ ...prev, avatar: null }))
                    } else {
                        setMediaError(prev => ({ ...prev, avatar: "Please upload an image file" }))

                    }
                    setAvatar(e.target.files[0]);
                }
            };
            if (e.target.files[0]) {
                reader.readAsDataURL(e.target.files[0]);
            }

        } else if (e.target.name === 'first_name') {
            setFirstName(e.target.value)
        } else if (e.target.name === 'last_name') {
            setLastName(e.target.value)
        } else if (e.target.name === 'email') {
            setEmail(e.target.value)
        } else if (e.target.name === 'contact_no') {
            setContactNo(e.target.value)
        }

    };
    const validate = () => {
        // let input = this.state.input;
        let errors = {};
        let isValid = true;
        if (!first_name) {
            isValid = false;
            errors["first_name"] = "Please enter your first name.";
        }
        if (typeof first_name !== "undefined") {
            let pattern = new RegExp(/^[a-zA-Z ]*$/);
            if (!pattern.test(first_name)) {
                isValid = false;
                errors["first_name"] = "Only alphabates are allowed for this field.";
            }
        }
        if (!last_name) {
            isValid = false;
            errors["last_name"] = "Please enter your first name.";
        }
        if (typeof last_name !== "undefined") {
            let pattern = new RegExp(/^[a-zA-Z ]*$/);
            if (!pattern.test(last_name)) {
                isValid = false;
                errors["last_name"] = "Only alphabates are allowed for this field";
            }
        }

        if (!email) {
            isValid = false;
            errors["email"] = "Please enter your email Address.";
        }
        if (typeof email !== "undefined") {
            let pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(email)) {
                isValid = false;
                errors["email"] = "Please enter valid email address.";
            }
        }
        if (!contact_no) {
            isValid = false;
            errors["contact_no"] = "Please enter your Mobile no.";
        }
        if (typeof contact_no !== "undefined") {
            let pattern = new RegExp(/^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/);
            if (!pattern.test(contact_no)) {
                isValid = false;
                errors["contact_no"] = "Enter valid mobile number.";
            }
        }

        setError(errors);

        return isValid;
    }
    const handleSubmit = (e) => {
        e.preventDefault();

        if (validate()) {
            dispatch({ type: UPDATE_PROFILE_RESET })
            setMediaError({})
            const formData = new FormData();
            formData.append('first_name', first_name);
            formData.append('last_name', last_name);
            formData.append('contact_no', contact_no);
            formData.append('email', email);
            formData.append('profile_pic', avatar);
            dispatch(updateProfile(formData))
            setAvatar()
        }
    };
    return (
        <div className="col-lg-8 col-md-12">
            <div className="card">
                <div className="body">
                    <ul className="nav nav-tabs-new">
                        <li className="nav-item"><a className="nav-link active" data-toggle="tab" href="#Profile">Profile</a></li>
                    </ul>
                </div>
            </div>
            <div className="tab-content padding-0">
                <div className="tab-pane active" id="Profile">

                    <div className="card">
                        <div className="header bline">
                            <h2>Basic Information</h2>
                        </div>
                        <div className="body">
                            <form onSubmit={handleSubmit} encType="multipart/form-data">
                                <div className="row clearfix">
                                    <div className="col-lg-6 col-md-12">
                                        <div className="form-group">
                                            <input
                                                type="file"
                                                name="avatar"
                                                className="form-control"
                                                id="customFile"
                                                accept="images/*"
                                                onChange={handleChange}
                                            />
                                        </div>
                                        {errors && errors.avatar && <p className='text-danger mt-2'>{errors.avatar}</p>}
                                        {mediaError.avatar && <p className='text-danger mt-2'>{mediaError.avatar}</p>}
                                    </div>
                                    <div className="col-lg-6 col-md-12">
                                        <div className="form-group">
                                            <input type="text" name="first_name" className="form-control" defaultValue={first_name} onChange={handleChange} placeholder="First Name" />
                                            {errors && errors.first_name && <p className='text-danger mt-2'>{errors.first_name}</p>}
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-12">
                                        <div className="form-group">
                                            <input type="text" name='last_name' defaultValue={last_name} onChange={handleChange} className="form-control" placeholder="Last Name" />
                                            {errors && errors.last_name && <p className='text-danger mt-2'>{errors.last_name}</p>}
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-12">
                                        <div className="form-group">
                                            <input type="email" required className="form-control" defaultValue={email} onChange={handleChange} name='email' placeholder="Please Enter Email"/>
                                            {errors && errors.email && <p className='text-danger mt-2'>{errors.email}</p>}
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-12">
                                        <div className="form-group">
                                            <PhoneInput
                                                className="form-control"
                                                defaultCountry="AU"
                                                countries={["AU"]}
                                                placeholder="Enter contact number"
                                                name="contact_no"
                                                value={contact_no} 
                                                onChange={(value)=>setContactNo(value)}
                                            />
                                            {/* <input type="text" name='contact_no' className="form-control" value={contact_no} onChange={handleChange} placeholder="Mobile Number" /> */}
                                            {errors && errors.contact_no && <p className='text-danger mt-2'>{errors.contact_no}</p>}
                                        </div>
                                    </div>
                                </div>
                                <button type="submit" className="btn button" disabled={loading ? true : false}>Update</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ProfileUpdate;